import React from 'react';

import cn from 'classnames';

import { ArrowIcon } from './ArrowIcon';
import { XCircleIcon } from './XCircleIcon';
import { IUiMultiSelectProps } from '../model/types';
import cls from '../UiMultiSelect.module.css';

interface IRightIcons {
    isEmptyValues: boolean;
    isOpen: boolean;
    arrowIconSlot?: IUiMultiSelectProps['arrowIconSlot'];
    clearIconSlot?: IUiMultiSelectProps['clearIconSlot'];
    clearCurrentValues: (e: React.SyntheticEvent) => void;
}

export const RightIcons = ({
    isEmptyValues,
    isOpen,
    arrowIconSlot,
    clearIconSlot,
    clearCurrentValues,
}: IRightIcons) =>
    !isEmptyValues ? (
        <button type="button" onClick={clearCurrentValues} className={cls.resetIcon}>
            {clearIconSlot || <XCircleIcon />}
        </button>
    ) : (
        <span className={cn(cls.arrowIcon, isOpen && cls.openArrow)}>
            {arrowIconSlot || <ArrowIcon />}
        </span>
    );
